import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params } from '@angular/router';
import { ApplicationPathConstants } from '@ddt-web/config';
import { ConfigService, LocaleUtilResolverService, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { AuthenticationManageService } from '@ddt-web/core';
import { SharedApplicationConstants } from '@ddt-web/domain';
import { StringUtil } from '@ddt-web/generic-utils';
import * as cloneDeep from 'lodash/cloneDeep';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Countries } from '../enums';

const DETAIL_LINK_KEYS = ['FUND_PERFORMANCE_AND_FEES', 'MODEL_FAMILY_DETAILS'];
@Injectable({
	providedIn: 'root'
})

export class MeRedirectGuard implements CanActivate {
	constructor(private localeUtilResolverService: LocaleUtilResolverService, private authManagerService: AuthenticationManageService, private configService: ConfigService) { }

	public canActivate(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
		const isAuthenticated$ = this.authManagerService.getUserAuthenticated();
		const act2Paths = this.configService.get(ModelsExperienceConfigKey.ACT2_PATHS, ApplicationPathConstants.ACT2_PATHS);
		return isAuthenticated$.pipe(
			take(1),
			map(authenticated => {
				if (authenticated) {
					const queryParams: Params = cloneDeep(childRoute.queryParams);
					const routeLocale = queryParams?.['locale'];
					const locale = routeLocale || this.localeUtilResolverService.getResolvedLocaleValue();

					//cms url or blk url
					const groupId = queryParams?.['groupId'];
					const subType = queryParams?.['subType'];
					let urlKey = childRoute.data?.['urlKey'];
					const detailLinkKeys = this.configService.get(ModelsExperienceConfigKey.DETAIL_LINK_KEYS, DETAIL_LINK_KEYS);
					if (groupId !== SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP && subType === 'CUSTOM' && detailLinkKeys.includes(urlKey)) {
						urlKey = urlKey + '_CMS';
					}

					if (locale === Countries['US'].toLowerCase() && urlKey) {
						let url = act2Paths[urlKey] || ApplicationPathConstants.ACT2_PATHS[urlKey];
						const familyId = queryParams?.['familyId'];

						if (url.includes('$$familyId$$') && familyId) {
							url = StringUtil.replaceAll(url, '$$familyId$$', familyId);
						}
						if (url.includes('$$pathName$$')) {
							const path = this.computePathName(childRoute.firstChild?.firstChild?.routeConfig?.path || '');
							url = StringUtil.replaceAll(url, '$$pathName$$', path);
						}
						window.open(url, '_self');
						return false;
					}
					return true;
				}
				return true;
			})
		);
	}

	public computePathName(path: string) {
		if (path === 'changes-holdings') {
			return 'changes-to-holdings';
		} else if (path === 'commentary') {
			return 'trade-rationale';
		}
		return path;
	}
}
